import { fork, all } from 'redux-saga/effects';
import helpSaga from './help';
import refundSaga from './refund';

export default function* serviceSaga() {
  yield all([fork(helpSaga), fork(refundSaga)]);
}
